
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 72 72","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M60.243 31.38c0 10.599-8.592 19.191-19.19 19.191-10.6 0-19.192-8.592-19.192-19.191 0-10.599 8.592-19.191 19.191-19.191 10.6 0 19.191 8.592 19.191 19.19z","fill":"#FFDC70"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M42.407 28.452a7.116 7.116 0 11-14.231 0 7.116 7.116 0 0114.231 0zM49.4 50.345c-.812-7.073-6.817-12.567-14.108-12.567s-13.296 5.494-14.108 12.567H49.4zM59.965 25.982a6.068 6.068 0 11-12.136 0 6.068 6.068 0 0112.136 0z","stroke":"#231F20"}}),_c('path',{attrs:{"d":"M50.579 44.652h15.349c-.693-6.032-5.813-10.717-12.031-10.717a12.08 12.08 0 00-9.37 4.444","stroke":"#231F20"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M12.092 25.982a6.068 6.068 0 1012.136 0 6.068 6.068 0 00-12.136 0z","stroke":"#231F20"}}),_c('path',{attrs:{"d":"M21.478 44.652H6.128c.693-6.032 5.814-10.717 12.032-10.717a12.08 12.08 0 019.37 4.444","stroke":"#231F20"}})])
          )
        }
      }
    